import { SelectInput } from '@/components/form';
import { REGION_OPTIONS } from '@/utils/constant/appConstant';
import { Col, Form, Modal, Row } from 'antd';
import React, { useEffect } from 'react';
import { TEAM_OPTIONS } from '../../constants';
import { useUpdateUser } from '../../hooks';
import { IUser } from '@/types';


interface EditRegionTeamModalProps {
  open: boolean;
  user: IUser | null;
  onClose: () => void;
  onSuccess: () => void;
  isRegionAll?: boolean;
  userRegion?: number;
}

export const EditRegionTeamModal: React.FC<EditRegionTeamModalProps> = ({
  open,
  user,
  onClose,
  onSuccess,
}) => {
  const [form] = Form.useForm();
  const updateUserMutation = useUpdateUser();



  useEffect(() => {
    if (open && user) {
      form.setFieldsValue({
        dogma_region: user.dogma_region || 3,
        dogma_team: user.dogma_team || 1,
      });
    }
  }, [open, user, form]);

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();

      // Update user region and team
      await updateUserMutation.mutateAsync({
        id: user!.systemuserid,
        payload: {
          dogma_region: values.dogma_region,
          dogma_team: values.dogma_team,
        },
      });

      onSuccess();
      onClose();
    } catch (error) {
    }
  };

  return (
    <Modal
      title="Edit Region & Team"
      open={open}
      onOk={handleSubmit}
      onCancel={onClose}
      okText="Save"
      cancelText="Cancel"
      width={600}
      confirmLoading={updateUserMutation.isPending}
    >
      <Form
        form={form}
        layout="vertical"
        className="mt-4"
      >
        <Row gutter={16}>
          <Col xs={24} sm={12}>
            <SelectInput
              name="dogma_region"
              label="Region"
              placeholder="Select region"
              options={REGION_OPTIONS}
              required
            />
          </Col>
          <Col xs={24} sm={12}>
            <SelectInput
              name="dogma_team"
              label="Team"
              placeholder="Select team"
              options={TEAM_OPTIONS}
            />
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default EditRegionTeamModal;
